"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidInterval = void 0;
const date_fns_1 = require("date-fns");
/**
 * @summary Determines if an interval is valid.
 *
 * Determines if an interval is valid. For an interval to be valid, both dates must be valid and the
 * end date must be equal to or after the start date.
 *
 * @param {Interval} interval
 * @returns {boolean}
 *
 * @example
 * if (!isValidInterval(interval)) {
 *   throw new BadRequestException();
 * }
 */
function isValidInterval(interval) {
    return (0, date_fns_1.getTime)(interval.start) <= (0, date_fns_1.getTime)(interval.end);
}
exports.isValidInterval = isValidInterval;
